export const GUEST_LOCALE_STORAGE_KEY = 'locale'
export const GUEST_THEME_STORAGE_KEY = 'theme'
